import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CollectionItemProps } from '../Components/CollectionStore/Types/CollectionItem';

interface CollectionStoreState {
  selectedCollectionItem?: CollectionItemProps;
  collectionItems: CollectionItemProps[];
  filteredItems: CollectionItemProps[];
}

const DEFAULT_STATE: CollectionStoreState = {
  selectedCollectionItem: undefined,
  collectionItems: [],
  filteredItems: [],
};

const CollectionStoreSlice = createSlice({
  name: 'collectionStore',
  initialState: DEFAULT_STATE,
  reducers: {
    setCollectionItem: (
      state,
      action: PayloadAction<{ item: CollectionItemProps }>
    ) => {
      state.selectedCollectionItem = action.payload.item;
    },
    SetCollectionItems: (
      state,
      action: PayloadAction<{ items: CollectionItemProps[] }>
    ) => {
      state.collectionItems = action.payload.items;
      state.filteredItems = action.payload.items;
    },
    SetFilteredItems: (
      state,
      action: PayloadAction<{ items: CollectionItemProps[] }>
    ) => {
      state.filteredItems = action.payload.items;
    },
  },
});

export const CollectionStoreActions = CollectionStoreSlice.actions;

export default CollectionStoreSlice.reducer;
